/**
 * 缓存数据
 */
import service from '@/utils/request.js'
import { localData } from "@/utils/local.js"

//缓存省市区
function getCity() {
  let _citys = localData("get", "XINYUAN_CITY");
  if (_citys) {
    // console.log("缓存种获取到城市数据: " + _citys);
    return Promise.resolve(_citys);
  } else {
    // console.log("缓存未获取到城市数据: " + _citys);
    return new Promise((resolve, reject) => {
      service.getRequest('/bs/data/district').then(res => {
        console.log(res);
        if (res.code == 0) {
          _citys = res.data;
          localData("set", "XINYUAN_CITY", _citys);
          resolve(_citys);
        }
      })
    });
  }
}

//缓存区域
function getOrgan() {
  let _organs = localData("get", "XINYUAN_ORGAN");
  if (_organs) {
    // console.log("缓存种获取到区域数据: " + _organs);
    return Promise.resolve(_organs);
  } else {
    // console.log("缓存未获取到区域数据: " + _organs);
    return new Promise((resolve, reject) => {
      service.getRequest('/bs/data/organization').then(res => {
        console.log(res);
        if (res.code == 0) {
          _organs = res.data;
          localData("set", "XINYUAN_ORGAN", _organs);
          resolve(_organs);
        }
      })
    });
  }
}

// 缓存一级来源
function getSource1() {
  let _source = localData("get", "XINYUAN_SOURCE");
  if (_source) {
    return Promise.resolve(_source);
  } else {
    return new Promise((resolve, reject) => {
      service.getRequest('/bs/data/source').then(res => {
        if (res.code == 0) {
          _source = res.data;
          localData("set", "XINYUAN_SOURCE", _source);
          resolve(_source);
        }
      })
    });
  }
}

// 缓存意向等级
function getWillingLevel() {
  let _level = localData("get", "XINYUAN_LEVEL");
  if (_level) {
    return Promise.resolve(_level);
  } else {
    return new Promise((resolve, reject) => {
      service.getRequest('/bs/data/willingLevel').then(res => {
        if (res.code == 0) {
          _level = res.data;
          localData("set", "XINYUAN_LEVEL", _level);
          resolve(_level);
        }
      })
    });
  }
}

// 缓存意向/订车/交车品牌
function getBrand() {
  let _brand = localData("get", "XINYUAN_BRAND");
  if (_brand) {
    return Promise.resolve(_brand);
  } else {
    return new Promise((resolve, reject) => {
      service.getRequest('/model/dropdown/list').then(res => {
        if (res.code == 0) {
          _brand = res.data;
          localData("set", "XINYUAN_BRAND", _brand);
          resolve(_brand);
        }
      })
    });
  }
}

export default {
  getCity,
  getOrgan,
  getSource1,
  getWillingLevel,
  getBrand,
}



// WEBPACK FOOTER //
// ./src/utils/xYuanLocal.js